"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newPageMetaEventHandler = exports.mapPathToPageType = exports.mapping = void 0;
var lodash_1 = require("lodash");
exports.mapping = [
    {
        category: 'inspiration',
        pages: [
            {
                regex: /^\/entdecken/,
                name: 'inspiration overview',
            },
            {
                regex: /^\/entdecken\/\w+/,
                name: 'inspiration article',
            },
        ],
    },
    {
        category: 'cruise search',
        pages: [
            {
                regex: /^\/finden\/?$/,
                name: 'cruise search overview',
            },
            {
                regex: /^\/finden\/\?.+/,
                name: 'cruise search results',
                virtPath: '/finden/searchresults',
            },
            {
                regex: /^\/finden\/\w+\/\w+/,
                name: 'cruise search detail',
            },
            {
                regex: /^\/hafen\/[\w-]+/,
                name: 'port detail',
            },
            {
                regex: /^\/finden\/excursions\/\w+/,
                name: 'excursions detail',
            },
        ],
    },
    {
        category: 'cruise',
        pages: [
            {
                regex: /^\/kreuzfahrt\/schiffe$/,
                name: 'ship overview',
            },
            {
                regex: /^\/kreuzfahrt\/schiffe\/\w+$/,
                name: 'ship detail',
            },
        ],
    },
    {
        category: 'campaign',
        pages: [
            {
                regex: /^\/kreuzfahrt\/angebote\/[\w-\/]+$/,
                name: 'campaign',
            },
        ],
    },
    {
        category: 'checkout',
        pages: [
            {
                regex: /^\/buchen\/.*\/meine-reise\/reisende/,
                name: 'booking step 1',
            },
            {
                regex: /^\/buchen\/.*\/meine-reise\/kabine/,
                name: 'booking step 2',
            },
            {
                regex: /^\/buchen\/.*\/meine-reise\/anreise/,
                name: 'booking step 3',
            },
            {
                regex: /^\/buchen\/.*\/meine-reise\/daten/,
                name: 'booking step 4',
            },
            {
                regex: /^\/buchen\/.*\/meine-reise\/versicherung/,
                name: 'booking step 5',
            },
            {
                regex: /^\/buchen\/.*\/meine-reise\/zusammenfassung/,
                name: 'booking step 6',
            },
            {
                regex: /^\/buchen\/\w+\/\w+\/buchung-erfolgt/,
                name: 'success',
            },
        ],
    },
    {
        category: 'cruise planning',
        pages: [
            {
                regex: /^\/planen\/\w+\?e=\d$/,
                name: 'planning overview',
            },
            {
                regex: /^\/planen\/\w+\/kategorie\/\w+$/,
                name: 'planning category',
            },
            {
                regex: /^\/planen\/\w+\/kategorie\/\w+\/\w+$/,
                name: 'planning subcategory',
            },
            {
                regex: /^\/planen\/\w+\/kategorie\/\w+\/tage\/\d+\/port\/\w+\/\w+$/,
                name: 'planning detail',
            },
            {
                regex: /^\/planen\/\w+\/kategorie\/\w+\/tage\/\d+\/port\/\w+$/,
                name: 'planning port',
            },
            {
                regex: /^\/planen\/\w+\/warenkorb$/,
                name: 'planning cart',
            },
            {
                regex: /^\/planen\/\w+\/kalender$/,
                name: 'planning calendar',
            },
            {
                regex: /^\/planen\/\w+\/reservierungen$/,
                name: 'planning reservation',
            },
            {
                regex: /^\/planen\/\w+\/reservierungen\/stonieren$/,
                name: 'planning cancel',
            },
            {
                regex: /^\/planen\/\w+\/erfolg\?isCancelCheckout=true$/,
                name: 'planning cancel success',
            },
            {
                regex: /^\/planen\/\w+\/erfolg$/,
                name: 'planning success page',
            },
        ],
    },
];
function mapPathToPageType(path, mapping) {
    for (var _i = 0, mapping_1 = mapping; _i < mapping_1.length; _i++) {
        var pageCategory = mapping_1[_i];
        for (var _a = 0, _b = pageCategory.pages; _a < _b.length; _a++) {
            var page = _b[_a];
            if (page.regex.test(path)) {
                return page.name;
            }
        }
    }
    return undefined;
}
exports.mapPathToPageType = mapPathToPageType;
function mapPathToPageCategory(path, mapping) {
    for (var _i = 0, mapping_2 = mapping; _i < mapping_2.length; _i++) {
        var pageCategory = mapping_2[_i];
        for (var _a = 0, _b = pageCategory.pages; _a < _b.length; _a++) {
            var page = _b[_a];
            if (page.regex.test(path)) {
                return pageCategory.category;
            }
        }
    }
    return undefined;
}
function getVirtPath(path) {
    for (var _i = 0, mapping_3 = exports.mapping; _i < mapping_3.length; _i++) {
        var pageCategory = mapping_3[_i];
        for (var _a = 0, _b = pageCategory.pages; _a < _b.length; _a++) {
            var page = _b[_a];
            if (page.regex.test(path) && page.virtPath) {
                return page.virtPath;
            }
        }
    }
    return undefined;
}
function newPageMetaEventHandler(mapping) {
    return function (mutation, state) {
        var path = mutation.payload.to.fullPath;
        var fromPath = getReferrer(mutation);
        var virtPath = (0, lodash_1.defaultTo)(getVirtPath(mutation.payload.to.fullPath), mutation.payload.to.path);
        var activated = (0, lodash_1.get)(state, 'realperson.activated', false);
        var available = (0, lodash_1.get)(state, 'realperson.available', false);
        var chatAvailability = activated && available ? 'chat available' : 'chat not available';
        var event = {
            event: 'gaVirtPath',
            language: 'DE',
            country: (0, lodash_1.get)(state, 'searching.exchangeRates.location', 'DE'),
            pageCategory: mapPathToPageCategory(path, mapping),
            pageType: mapPathToPageType(path, mapping),
            userId: '',
            loginStatus: 'not logged',
            chatAvailability: chatAvailability,
            pagePathVirt: virtPath,
            campaignID: (0, lodash_1.get)(state, 'campaigns.info.pricePlanCodes', []).join('/'),
            pagePathPrevious: fromPath,
            aidaSource: (0, lodash_1.get)(state, 'tracking.bea.aidaSource'),
            userType: (0, lodash_1.get)(state, 'tracking.bea.userType'),
        };
        return [event];
    };
}
exports.newPageMetaEventHandler = newPageMetaEventHandler;
function getReferrer(mutation) {
    var fullPath = mutation.payload.from.fullPath;
    if (typeof window !== 'undefined' &&
        document.referrer !== '' &&
        fullPath === '/') {
        return document.referrer;
    }
    return "".concat(getDomain()).concat(mutation.payload.from.fullPath);
}
function getDomain() {
    if (typeof document !== 'undefined') {
        return document.domain || '';
    }
}
//# sourceMappingURL=page_meta_event.js.map